import { Loader2 } from "lucide-react";

export function LoadingSpinner({ className = "h-6 w-6" }: { className?: string }) {
  return (
    <div className="flex items-center justify-center">
      <Loader2 className={`${className} animate-spin`} />
    </div>
  );
}
